export default function AboutPage() {
  return (
    <div className="max-w-4xl mx-auto px-6 pt-8 pb-16">
      <section className="mb-14">
        <h1 className="text-2xl font-extrabold text-text-primary mb-2">关于我们</h1>
        <p className="text-text-secondary text-sm">从第一颗螺丝到无限可能。拼装 / 改装 / 编程 / 对战，一辆车，无限可能。</p>
      </section>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-14">
        {[
          { t: '产品故事', d: 'RoboRush 源于一个简单的想法——玩具遥控车玩三天就腻，编程课学完和现实世界没有任何连接。我们要做的不是"教编程的玩具"，而是让每一个孩子亲手拼出属于自己的战车，然后开着它走上赛场。', c: '#FF3B3B' },
          { t: '核心团队', d: '团队由机器人教育、嵌入式硬件、赛事运营三个领域的从业者组成。目前处于产品原型阶段，正在寻找首批合作学校和测试用户。', c: '#00C2FF' },
          { t: '联系我们', d: '商务合作：biz@modular-robot.cn\n赛事咨询：events@modular-robot.cn\n技术支持：support@modular-robot.cn\n媒体合作：press@modular-robot.cn', c: '#FFB800' },
        ].map((s) => (
          <div key={s.t} className="bg-panel-dark/40 border border-border-dark rounded-card-lg mecha-card mecha-bolt p-6">
            <div className="w-2 h-2 rounded-full mb-3" style={{ backgroundColor: s.c }} />
            <h2 className="text-base font-extrabold text-text-primary mb-3">{s.t}</h2>
            <p className="text-xs text-text-secondary leading-relaxed whitespace-pre-line">{s.d}</p>
          </div>
        ))}
      </div>

      <div className="bg-panel-dark/40 border border-border-dark rounded-card-lg mecha-card mecha-bolt p-6 mb-8">
        <h2 className="text-lg font-extrabold text-text-primary mb-4">隐私政策</h2>
        <div className="space-y-4 text-xs text-text-secondary leading-relaxed">
          <div>
            <h3 className="text-sm font-semibold text-text-primary mb-1">信息收集</h3>
            <p>我们仅在您注册账号、报名赛事或购买商品时收集必要的个人信息（昵称、邮箱、邮寄地址）。车辆主板不收集任何个人隐私数据。</p>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-text-primary mb-1">数据使用</h3>
            <p>赛事数据（碰撞力度、圈速、排名）用于竞技排名和社区展示。您可以随时在账户设置中选择不公开个人赛事数据。</p>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-text-primary mb-1">第三方服务</h3>
            <p>我们使用第三方支付平台处理商城交易，支付信息由支付平台直接处理，我们不会存储您的银行卡或支付账户信息。</p>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-text-primary mb-1">联系我们</h3>
            <p>如有隐私相关问题，请联系 privacy@modular-robot.cn</p>
          </div>
        </div>
      </div>

      <div className="bg-panel-dark/40 border border-border-dark rounded-card-lg mecha-card mecha-bolt p-5">
        <p className="text-xs text-text-disabled text-center">辽ICP备2026012818号-2 | 公安备案号 | 营业执照信息（占位，待运营后补充）</p>
      </div>
    </div>
  );
}
